import clsx from "clsx"

export interface FadeInProps {
  children: React.ReactNode
  className?: string
}

const FadeIn = ({ children, className }: FadeInProps) => {
  return <div className={clsx("animate-fade-in", className)}>{children}</div>
}

export default FadeIn
